export enum Section {
  Standard = 1,
  AsBook = 12,
}
